<template>
  <div class="my_launch">
    <div class="tit">
      <span v-if="isCertified !== 1">我的拼购</span>
      <div class="tab" v-else>
        <router-link
          to="/personal_center/park_user/my_purchase/purchase_record/my_launch"
          tag="span"
          class="sp"
        >我的发起</router-link>
        <router-link
          to="/personal_center/park_user/my_purchase/purchase_record/my_join"
          tag="span"
          class="sp"
        >我的参与</router-link>
      </div>
    </div>
    <div class="body_content" v-if="isCertified === 1">
      <div class="btns">
        <div class="btn_left">
          <el-button type="primary" @click="add">发起拼购</el-button>
        </div>
      </div>
      <router-view></router-view>
      <!-- <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable> -->
    </div>
    <div class="body_content" v-if="isCertified === 2">
      <div class="btns">
        <div class="btn_left">
         <el-button type="primary" @click="toEmployeeCertify">认证为员工</el-button>
          <el-button type="primary" @click="toEnterpriseCertify">认证为企业</el-button>
        </div>
      </div>
      <!-- <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable> -->
    </div>
  </div>
</template>
<script>
import myTable from "@/components/my_table.vue";
export default {
  components: {
    myTable
  },
  data() {
    return {
      form: {
        name: "",
        detail: "",
        release_date: "",
        end_date: "",
        money: "",
        money_unit: "",
        link: "",
        tips: "",
        end_time: "",
        user_id: sessionStorage.getItem("userId")
      },
      tableObj: {
        list: [],
        btns: [
          {
            name: "查看拼购详情",
            funcName: "toPurchaseDetail"
          }
        ],
        table_selection: false,
        table_detail: [
          {
            prop: "name",
            label: "拼购信息"
          },
          {
            prop: "release_date",
            label: "发起时间"
          },
          {
            prop: "end_date",
            label: "结束时间"
          },
          {
            prop: "count",
            label: "同求人数"
          },
          {
            prop: "status_name",
            label: "接龙状态",
            formatter: function(row) {
              return `<span class="">${row.status_name}</span>`;
            }
          }
        ],
        layerpageinfo: {
          //分页
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      },
      index: 0,
      isCertified: 0
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.info) {
      this.certified();
    } else {
      this.needInfo("certified");
    }
  },
  methods: {
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          console.log(this.info);

          this[fn]();
          watchAch(); //取消监听
        }
      });
    },

    //跳转员工认证
    toEmployeeCertify() {
      this.$router.push({ name: "employee_certification" });
    },
    //跳转企业认证
    toEnterpriseCertify() {
      this.$router.push({ name: "enterprise_certification" });
    },
    //发起拼购
    add() {
      this.$router.push({
        path: "/personal_center/park_user/my_purchase/launch_purchase"
      });
    },
    /* 获取个人信息 */
    certified() {
      if (this.info.role === "UserRoleOrdinary") {
        this.isCertified = 2;
      } else {
        this.isCertified = 1;
      }
    }
  }
};
</script>
<style lang="scss">
.tit {
  .tab {
    .sp {
      cursor: pointer;
      margin-right: 10px;
      font-size: 13px;
    }
    .router-link-active {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>